<template>
  <div class="funding-plan-container">
    <!-- 顶部输入区域 -->
    <div class="input-section">
      <div class="input-row">
        <div class="input-item">
          <label class="input-label">债务资金类别</label>
          <select
            v-model="category"
            class="input-select"
            @change="loadCategoryData"
          >
            <option value="银行借款">银行借款</option>
            <option value="债券">债券</option>
            <option value="融资租赁">融资租赁</option>
            <option value="其他借款">其他借款</option>
          </select>
        </div>
        <div class="input-item">
          <label class="input-label">借款额度(万元)</label>
          <input
            type="number"
            v-model.number="debtFundForm.amount"
            class="input-number"
            placeholder="0.00"
            step="0.01"
            min="0"
            :max="getMaxAmount()"
            @input="zj"
          />
        </div>
        <div class="input-item">
          <label class="input-label">利率(%)</label>
          <input
            type="number"
            v-model.number="debtFundForm.rate"
            class="input-number"
            placeholder="0.00"
            step="0.01"
            min="0"
            max="50"
            :disabled="debtFundForm.amount <= 0"
          />
        </div>
        <div class="input-item">
          <label class="input-label">{{ getBorrowPeriodLabel() }}</label>
          <select
            v-model.number="debtFundForm.startyear"
            class="input-select"
            :disabled="debtFundForm.amount <= 0"
            @change="handleAmountChange"
          >
            <option v-for="i in getConstructionPeriod()" :key="i" :value="i">
              第{{ i }}期
            </option>
          </select>
        </div>
        <div class="input-item">
          <label class="input-label">期限(年)</label>
          <input
            type="number"
            v-model.number="debtFundForm.term"
            class="input-number"
            placeholder="1"
            min="1"
            :disabled="debtFundForm.amount <= 0"
            @change="handleAmountChange"
          />
        </div>
        <div class="input-item">
          <label class="input-label">{{ getjidu() }}</label>
          <select
            v-model="debtFundForm.quarter"
            class="input-select"
            :disabled="debtFundForm.amount <= 0"
          >
            <option v-for="i in 4" :key="i" :value="i">第{{ i }}季度</option>
          </select>
        </div>
        <div class="input-item">
          <label class="input-label">还款方式</label>
          <select
            v-model="debtFundForm.Repayment"
            class="input-select"
            :disabled="debtFundForm.amount <= 0"
          >
            <option value="逐年付息期末还本">逐年付息期末还本</option>
            <option value="等额本息">等额本息</option>
            <option value="期末本息">期末本息</option>
          </select>
        </div>

        <div class="input-item button-item">
          <button class="add-btn" @click="addDebtFund">确定</button>
        </div>
      </div>
    </div>

    <!-- 表格容器 -->
    <div class="table-container">
      <table class="funding-table">
        <thead>
          <tr>
            <th class="sequence-col">序号</th>
            <th class="amount-col">资金来源类别</th>
            <th class="amount-col">金额（万元）</th>
            <th class="ratio-col">占总投资比例（%）</th>
            <th class="source-col">筹措方法</th>
          </tr>
        </thead>
        <tbody>
          <!-- 分组行 -->
          <tr class="group-row">
            <td>一</td>
            <td class="name-cell">项目资本金</td>
            <td class="amount-cell">
              {{ formatNumber(cc.项目资本金.amount) }}
            </td>
            <td>{{ formatPercent(cc.项目资本金.proportion * 100) }}%</td>
            <td></td>
          </tr>
          <tr class="group-row">
            <td>二</td>
            <td class="name-cell">债务资金</td>
            <td class="amount-cell">{{ formatNumber(cc.债务资金.amount) }}</td>
            <td>{{ formatPercent(cc.债务资金.proportion * 100) }}%</td>
            <td></td>
          </tr>

          <!-- 数据行 -->
          <tr>
            <td>1</td>
            <td class="name-cell">银行借款</td>
            <td>
              <!-- 项目资本金金额计算 -->
              <span class="amount-display">
                {{ formatNumber(cc.债务资金.银行借款.amount) }}
              </span>
            </td>
            <td>{{ formatPercent(cc.债务资金.银行借款.proportion * 100) }}%</td>
            <td>
              <!-- 债务资金额外字段 - 只有当有金额值时才显示 -->
              <div v-if="cc.债务资金.银行借款.amount > 0" class="debt-fields">
                <div class="field-row">
                  <span class="field-label">利率:</span>
                  <span
                    >{{ formatNumber(cc.债务资金.银行借款.rate || 0) }}%</span
                  >
                </div>
                <div class="field-row">
                  <span class="field-label">借入期:</span>
                  <span>第{{ cc.债务资金.银行借款.startyear }}期</span>
                </div>
                <div class="field-row">
                  <span class="field-label">期限:</span>
                  <span>{{ cc.债务资金.银行借款.term }}年</span>
                </div>
                <div class="field-row">
                  <span class="field-label">借入季度:</span>
                  <span>第{{ cc.债务资金.银行借款.quarter }}季度</span>
                </div>
                <div class="field-row">
                  <span class="field-label">还款方式:</span>
                  <span>{{ cc.债务资金.银行借款.Repayment }}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td class="name-cell">债券</td>
            <td>
              <!-- 项目资本金金额计算 -->
              <span class="amount-display">
                {{ formatNumber(cc.债务资金.债券.amount) }}
              </span>
            </td>
            <td>{{ formatPercent(cc.债务资金.债券.proportion * 100) }}%</td>
            <td>
              <!-- 债务资金额外字段 - 只有当有金额值时才显示 -->
              <div v-if="cc.债务资金.债券.amount > 0" class="debt-fields">
                <div class="field-row">
                  <span class="field-label">利率:</span>
                  <span>{{ formatNumber(cc.债务资金.债券.rate || 0) }}%</span>
                </div>
                <div class="field-row">
                  <span class="field-label">发行期:</span>
                  <span>第{{ cc.债务资金.债券.startyear }}期</span>
                </div>
                <div class="field-row">
                  <span class="field-label">期限:</span>
                  <span>{{ cc.债务资金.债券.term }}年</span>
                </div>
                <div class="field-row">
                  <span class="field-label">发行季度:</span>
                  <span>第{{ cc.债务资金.债券.quarter }}季度</span>
                </div>

                <div class="field-row">
                  <span class="field-label">还款方式:</span>
                  <span>{{ cc.债务资金.债券.Repayment }}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>3</td>
            <td class="name-cell">融资租赁</td>
            <td>
              <!-- 项目资本金金额计算 -->
              <span class="amount-display">
                {{ formatNumber(cc.债务资金.融资租赁.amount) }}
              </span>
            </td>
            <td>{{ formatPercent(cc.债务资金.融资租赁.proportion * 100) }}%</td>
            <td>
              <!-- 债务资金额外字段 - 只有当有金额值时才显示 -->
              <div v-if="cc.债务资金.融资租赁.amount > 0" class="debt-fields">
                <div class="field-row">
                  <span class="field-label">利率:</span>
                  <span
                    >{{ formatNumber(cc.债务资金.融资租赁.rate || 0) }}%</span
                  >
                </div>
                <div class="field-row">
                  <span class="field-label">租入期:</span>
                  <span>第{{ cc.债务资金.融资租赁.startyear }}期</span>
                </div>
                <div class="field-row">
                  <span class="field-label">期限:</span>
                  <span>{{ cc.债务资金.融资租赁.term }}年</span>
                </div>
                <div class="field-row">
                  <span class="field-label">租入季度:</span>
                  <span>第{{ cc.债务资金.融资租赁.quarter }}季度</span>
                </div>
                <div class="field-row">
                  <span class="field-label">还款方式:</span>
                  <span>{{ cc.债务资金.融资租赁.Repayment }}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>4</td>
            <td class="name-cell">其他借款</td>
            <td>
              <!-- 项目资本金金额计算 -->
              <span class="amount-display">
                {{ formatNumber(cc.债务资金.其他借款.amount) }}
              </span>
            </td>
            <td>{{ formatPercent(cc.债务资金.其他借款.proportion * 100) }}%</td>
            <td>
              <!-- 债务资金额外字段 - 只有当有金额值时才显示 -->
              <div v-if="cc.债务资金.其他借款.amount > 0" class="debt-fields">
                <div class="field-row">
                  <span class="field-label">利率:</span>
                  <span
                    >{{ formatNumber(cc.债务资金.其他借款.rate || 0) }}%</span
                  >
                </div>
                <div class="field-row">
                  <span class="field-label">借入期:</span>
                  <span>第{{ cc.债务资金.其他借款.startyear }}期</span>
                </div>
                <div class="field-row">
                  <span class="field-label">期限:</span>
                  <span>{{ cc.债务资金.其他借款.term }}年</span>
                </div>
                <div class="field-row">
                  <span class="field-label">借入季度:</span>
                  <span>第{{ cc.债务资金.其他借款.quarter }}季度</span>
                </div>
                <div class="field-row">
                  <span class="field-label">还款方式:</span>
                  <span>{{ cc.债务资金.其他借款.Repayment }}</span>
                </div>
              </div>
            </td>
          </tr>

          <!-- 总计行 -->
          <tr class="total-row">
            <td></td>
            <td class="name-cell">资金筹措总额</td>
            <td class="amount-cell">{{ formatNumber(cc.amount) }}</td>
            <td>100.00%</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Financing } from "@/utils/comp.js";

export default {
  name: "FundingPlan",
  props: {
    isViewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      projectData: {},
      cc: {
        amount: 0,
        项目资本金: {
          amount: 0,
          proportion: 0,
        },
        债务资金: {
          amount: 0,
          proportion: 0,
          银行借款: {
            amount: 0,
            proportion: 0,
            rate: 0,
            term: 0,
            startyear: 1,
            quarter: 3,
            Repayment: "逐年付息期末还本",
          },
          债券: {
            amount: 0,
            proportion: 0,
            rate: 0,
            term: 0,
            startyear: 1,
            quarter: 3,
            Repayment: "逐年付息期末还本",
          },
          融资租赁: {
            amount: 0,
            proportion: 0,
            rate: 0,
            term: 0,
            startyear: 1,
            quarter: 3,
            Repayment: "逐年付息期末还本",
          },
          其他借款: {
            amount: 0,
            proportion: 0,
            rate: 0,
            term: 0,
            startyear: 1,
            quarter: 3,
            Repayment: "逐年付息期末还本",
          },
        },
      },
      category: "银行借款",
      fundingData: [],
      debtFundForm: {
        amount: 0,
        term: 0,
        rate: 0,
        startyear: 1,
        quarter: 3,
        Repayment: "逐年付息期末还本",
      },
    };
  },

  created() {
    // 初始化时调用计算函数，然后读出Vuex中的所有数据
    this.cc = Financing();
    this.loadDataFromVuex();
  },

  // mounted() {
  //   // 组件挂载后执行一次计算

  //   this.loadDataFromVuex();
  // },

  methods: {
    // 从Vuex加载数据
    loadDataFromVuex() {
      this.projectData = this.$store.state.projectData || {};

      // 确保数据结构存在
      if (!this.projectData.资金筹措及分年投资计划) {
        this.projectData.资金筹措及分年投资计划 = {};
      }
      if (!this.projectData.资金筹措及分年投资计划.资金筹措) {
        this.projectData.资金筹措及分年投资计划.资金筹措 = {
          amount: 0, //资金筹措总额，等于资金筹措总额+债务资金总额，恒等于总投资估算.总表.总投资.合计
          proportion: 1, //与资金筹措总额的比例
          项目资本金: {
            amount: 0, //项目资本金总额，等于资金筹措总额-债务资金.amount
            proportion: null, //项目资本金总额与资金筹措总额的比例
          },
          债务资金: {
            amount: 0, //债务资金总额,等于银行借款.amount+债券.amount+融资租赁.amount+其他借款.amount
            proportion: null, //债务资金总额与资金筹措总额的比例
            interest: 0, //建设期利息
            loan: [],
            interestlist: [], //建设期利息分年列表
            operating: [],
            银行借款: {
              amount: 0, //银行借款总额
              proportion: null, //银行借款总额与资金筹措总额的比例
              term: 0, //银行借款期限
              rate: 0, //银行借款利率
              startyear: 1, //银行借款开始年
              quarter: 3, //银行借款开始季度
              interest: 0, //建设期利息
              loan: [],
              interestlist: [], //建设期利息分年列表
              operating: [],
              Repayment: "逐年付息期末还本",
            },
            债券: {
              amount: 0, //债券总额
              proportion: null, //债券总额与资金筹措总额的比例
              term: 0, //债券期限
              rate: 0, //债券利率
              startyear: 1, //债券开始年
              quarter: 3, //债券开始季度
              interest: 0, //建设期利息
              loan: [],
              interestlist: [], //建设期利息分年列表
              operating: [],
              Repayment: "逐年付息期末还本",
            },
            融资租赁: {
              amount: 0, //融资总额
              proportion: 1, //融资总额与资金筹措总额的比例
              term: 0, //融资期限
              rate: 0, //融资利率
              startyear: 1, //融资开始年
              quarter: 3, //融资开始季度
              interest: 0, //建设期利息
              loan: [],
              interestlist: [], //建设期利息分年列表
              operating: [],
              Repayment: "逐年付息期末还本",
            },
            其他借款: {
              amount: 0, //其他借款总额
              proportion: 1, //其他借款总额与资金筹措总额的比例
              term: 0, //其他借款期限
              rate: 0, //其他借款利率
              startyear: 1, //其他借款开始年
              quarter: 3, //其他借款开始季度
              interest: 0, //建设期利息
              loan: [],
              interestlist: [], //建设期利息分年列表
              operating: [],
              Repayment: "逐年付息期末还本",
            },
          },
        };
      }
      this.cc = this.projectData.资金筹措及分年投资计划.资金筹措;
      this.jichu = this.projectData.基础数据;

      this.category = "银行借款";
      this.debtFundForm.amount = this.cc.债务资金.银行借款.amount;
      this.debtFundForm.term = this.cc.债务资金.银行借款.term;
      this.debtFundForm.rate = this.cc.债务资金.银行借款.rate;
      this.debtFundForm.startyear = this.cc.债务资金.银行借款.startyear;
      this.debtFundForm.quarter = this.cc.债务资金.银行借款.quarter;
    },

    // 加载类别数据
    loadCategoryData() {
      const currentData =
        this.projectData.资金筹措及分年投资计划.资金筹措.债务资金[
          this.category
        ];

      this.debtFundForm.amount = currentData?.amount || 0;
      this.debtFundForm.term = currentData?.term || 0;
      this.debtFundForm.rate = currentData?.rate || 0;
      this.debtFundForm.startyear = currentData?.startyear || 1;
      this.debtFundForm.quarter = currentData?.quarter || 3;
    },

    // 添加债务资金
    async addDebtFund() {
      // 1. 先保存修改后的参数到Vuex
      const fundingPlan = this.projectData.资金筹措及分年投资计划.资金筹措;
      const debtTypes = ["银行借款", "债券", "融资租赁", "其他借款"];

      // 检查债务资金总额是否超过总投资
      const totalInvestment =
        this.projectData.总投资估算?.总表?.总投资?.合计 || 0;
      const currentCategoryAmount =
        this.cc.债务资金?.[this.category]?.amount || 0;
      const totalDebtAmount = this.cc.债务资金?.amount || 0;

      if (
        totalDebtAmount - currentCategoryAmount + this.debtFundForm.amount >
        totalInvestment
      ) {
        this.$message.error("债务资金总额不能大于总投资！");
        this.debtFundForm.amount = currentCategoryAmount;
        return;
      }

      // 移除无效的建设期利息检查，因为利息是在Financing函数中计算的，而不是在这里

      // 更新项目数据中的资金筹措数据
      if (!this.projectData.资金筹措及分年投资计划) {
        this.projectData.资金筹措及分年投资计划 = {};
      }
      if (!this.projectData.资金筹措及分年投资计划.资金筹措) {
        this.projectData.资金筹措及分年投资计划.资金筹措 = {
          amount: 0,
          项目资本金: { amount: 0, proportion: null },
          债务资金: {
            amount: 0,
            proportion: null,
            银行借款: {
              amount: 0,
              proportion: null,
              term: 0,
              rate: 0,
              startyear: 1,
              quarter: 3,
              Repayment: "逐年付息期末还本",
              interest: 0,
              interestlist: [],
            },
            债券: {
              amount: 0,
              proportion: null,
              term: 0,
              rate: 0,
              startyear: 1,
              quarter: 3,
              Repayment: "逐年付息期末还本",
              interest: 0,
              interestlist: [],
            },
            融资租赁: {
              amount: 0,
              proportion: null,
              term: 0,
              rate: 0,
              startyear: 1,
              quarter: 3,
              Repayment: "逐年付息期末还本",
              interest: 0,
              interestlist: [],
            },
            其他借款: {
              amount: 0,
              proportion: null,
              term: 0,
              rate: 0,
              startyear: 1,
              quarter: 3,
              Repayment: "逐年付息期末还本",
              interest: 0,
              interestlist: [],
            },
          },
        };
      }

      // 更新当前类别的债务资金数据
      this.projectData.资金筹措及分年投资计划.资金筹措.债务资金[this.category] =
        {
          ...this.projectData.资金筹措及分年投资计划.资金筹措.债务资金[
            this.category
          ],
          amount: this.debtFundForm.amount,
          proportion: null,
          term: this.debtFundForm.term,
          rate: this.debtFundForm.rate,
          startyear: this.debtFundForm.startyear,
          quarter: this.debtFundForm.quarter,
          Repayment: this.debtFundForm.Repayment,
        };

      // 计算债务资金总额
      let calculatedDebtTotal = 0;
      debtTypes.forEach((type) => {
        calculatedDebtTotal +=
          this.projectData.资金筹措及分年投资计划.资金筹措.债务资金[type]
            .amount;
      });
      this.projectData.资金筹措及分年投资计划.资金筹措.债务资金.amount =
        calculatedDebtTotal;

      // 计算项目资本金
      const grandTotal =
        parseFloat(this.projectData.总投资估算?.总表?.总投资?.合计) || 0;
      this.projectData.资金筹措及分年投资计划.资金筹措.项目资本金.amount =
        grandTotal - calculatedDebtTotal;

      // 保存到Vuex
      this.$store.commit("SET_PROJECT_DATA", this.projectData);

      // 2. 然后调用计算函数并检查返回结果
      const result = await Financing();

      // 检查是否有验证错误
      if (result && result.success === false) {
        this.$message.error(result.error);

        // 重置输入框为0
        this.debtFundForm.amount = 0;
        this.debtFundForm.rate = 0;

        // 重新获取数据以恢复之前的状态
        // await this.loadFundingData();
        return;
      }

      // 3. 然后再次调用loadFundingData获取最新计算结果
      // await this.loadFundingData();

      // 重置表单
      // this.debtFundForm = {
      //   amount: 0,
      //   rate: 0,
      //   term: 0,
      //   startyear: 1,
      //   quarter: 3,
      // };
    },

    zj() {
      // 计算新的债务资金总额
      const newDebtTotal =
        this.cc.债务资金.amount -
        this.cc.债务资金[`${this.category}`].amount +
        this.debtFundForm.amount;

      // 检查债务资金总额是否超过总投资
      if (newDebtTotal > this.projectData.总投资估算.总表.总投资.合计) {
        this.$message.error("债务资金总额不能大于总投资！");
        this.debtFundForm.amount = this.cc.债务资金[`${this.category}`].amount;
        return;
      }

      // 计算项目资本金（总投资 - 新的债务资金总额）
      const newCapital =
        this.projectData.总投资估算.总表.总投资.合计 - newDebtTotal;

      // 检查资本金是否为负数
      if (newCapital < 0) {
        this.$message.error("项目资本金不能为负数，请调整借款额度！");
        this.debtFundForm.amount = 0;
        return;
      }

      // 检查建设期利息是否超过资本金
      const newTotalInterest = this.calculateTotalInterest();
      if (newTotalInterest > newCapital) {
        this.$message.error("建设期利息总额超过项目资本金，不允许！");
        // 将借款额度或利率设为0
        if (this.debtFundForm.amount > 0) {
          this.debtFundForm.amount = 0;
        } else if (this.debtFundForm.rate > 0) {
          this.debtFundForm.rate = 0;
        }
        return;
      }

      // 调用计算函数并检查返回结果
      const result = Financing();

      // 检查是否有验证错误
      if (result && result.success === false) {
        this.$message.error(result.error);

        // 重置输入框为0
        this.debtFundForm.amount = 0;
        this.debtFundForm.rate = 0;

        // 重新读取数据以恢复之前的状态
        this.loadDataFromVuex();
        return;
      }

      this.handleAmountChange();
    },
    handleAmountChange() {
      if (
        this.debtFundForm.term <
        this.jichu.constructionPeriod - this.debtFundForm.startyear + 2
      ) {
        // this.$message.error("借款到期日不能在建设期内!");

        this.debtFundForm.term =
          this.jichu.constructionPeriod - this.debtFundForm.startyear + 2;
      }
    },

    // 获取借入期标签文本
    getBorrowPeriodLabel() {
      return this.category === "债券"
        ? "发行期"
        : this.category === "融资租赁"
        ? "租入期"
        : "借入期";
    },
    getjidu() {
      return this.category === "债券"
        ? "发行季度"
        : this.category === "融资租赁"
        ? "租入季度"
        : "借入季度";
    },

    // 获取显示用的借入期标签
    getDisplayBorrowPeriodLabel(item) {
      if (item.name === "债券") return "发行期";
      if (item.name === "融资租赁") return "租入期";
      return "借入期";
    },

    // 格式化数字
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) return "0.00";
      if (num === 0) return "0.00";
      return Number(num)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // 格式化百分比
    formatPercent(num) {
      if (num === null || num === undefined || isNaN(num)) return "0.00";
      return Number(num).toFixed(2);
    },

    // 获取建设期
    getConstructionPeriod() {
      return this.projectData.基础数据?.constructionPeriod || 1;
    },

    // 计算总建设期利息
    calculateTotalInterest() {
      let totalInterest = 0;
      const debtTypes = ["银行借款", "债券", "融资租赁", "其他借款"];

      debtTypes.forEach((type) => {
        const debtData = this.cc.债务资金?.[type];
        if (debtData && debtData.interest) {
          totalInterest += debtData.interest;
        }
      });

      return totalInterest;
    },

    // 获取总投资
    getGrandTotal() {
      return parseFloat(this.projectData.总投资估算?.总表?.总投资?.合计) || 0;
    },

    // 计算债务资金总额
    getDebtTotal() {
      return (
        this.projectData.资金筹措及分年投资计划?.资金筹措?.债务资金?.amount || 0
      );
    },

    // 最大借款额度
    getMaxAmount() {
      return this.getGrandTotal() - this.getDebtTotal();
    },

    // 检查银行借款是否有值，用于控制输入框的启用状态
    isBankLoanEnabled() {
      const bankLoanAmount =
        this.projectData.资金筹措及分年投资计划?.资金筹措?.债务资金?.银行借款
          ?.amount || 0;
      return bankLoanAmount > 0;
    },

    // 检查是否应该禁用输入框
    isInputDisabled() {
      // 如果是银行借款且有金额，或者不是银行借款（可以自由添加其他类型）
      return this.category !== "银行借款" && !this.isBankLoanEnabled();
    },
  },
};
</script>

<style scoped>
.funding-plan-container {
  padding: 20px;
  background: #f5f7fa;
}

.component-header {
  margin-bottom: 20px;
}

.component-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

/* 顶部输入区域样式 */
.input-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.input-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.input-item {
  display: flex;
  flex-direction: column;
  min-width: 100px;
}

.input-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.input-select {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  transition: border-color 0.3s;
}

.input-select:focus {
  outline: none;
  border-color: #409eff;
}

.input-select:disabled {
  background: #f5f7fa;
  color: #909399;
  cursor: not-allowed;
}

.input-number {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px 6px;
  font-size: 14px;
  text-align: right;
  transition: border-color 0.3s;
  background: white;
  width: 80px;
}

.input-number:focus {
  outline: none;
  border-color: #409eff;
}

.input-number:disabled {
  background: #f5f7fa;
  color: #909399;
  cursor: not-allowed;
}

.button-item {
  align-self: flex-end;
}

.add-btn {
  padding: 8px 20px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.add-btn:hover {
  background: #66b1ff;
}

.add-btn:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
}

.table-container {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.funding-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.funding-table th,
.funding-table td {
  border: 1px solid #e4e7ed;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}

.funding-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #303133;
}

.sequence-col {
  width: 40px;
}

.name-col {
  width: 150px;
  text-align: left !important;
}

.amount-col {
  width: 100px;
}

.ratio-col {
  width: 100px;
}

.source-col {
  width: 250px;
}

.name-cell {
  text-align: left;
  font-weight: 500;
}

.group-row .name-cell {
  text-align: center;
  font-weight: 600;
}

.amount-cell {
  font-weight: 600;
  background: #f0f9eb;
}

.amount-display {
  font-weight: 600;
  color: #409eff;
}

.table-input {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  text-align: center;
  transition: border-color 0.3s;
  background: white;
}

.table-input:focus {
  outline: none;
  border-color: #409eff;
}

.table-input:disabled {
  background: #f5f7fa;
  color: #909399;
  cursor: not-allowed;
}

.small-input {
  width: 60px;
}

.debt-fields {
  font-size: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  /* flex-wrap: nowrap; */
  justify-content: space-around;
}

.field-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.field-label {
  margin-right: 8px;
  font-size: 10px;
  color: #606266;
}

.field-unit {
  margin-left: 4px;
  font-size: 10px;
  color: #606266;
}

.group-row {
  background: #f9fafc;
  font-weight: 600;
}

.total-row {
  background: #f0f9eb;
  font-weight: 700;
}
</style>
